<div class="spinner-wrapper">
  Loading data
  <shared-local-dot-loader />
</div>
